module.exports = __webpack_public_path__ + "img/banner-regalos-movil.8c9a3206.png";